import React from 'react'
import { Tooltip } from 'antd'
import type { IdeonCompareRow } from '../api/ideon-compare-api'
import { formatDisplayValue } from '../utils/compareDataHelpers'
import styles from '../PlanManagementV3.module.scss'

/** The value a cell shows: removed rows only have a base value. */
export function getIdeonCellValue(
  row: IdeonCompareRow,
  fieldKey: string
): string {
  const field = row.fieldCompare[fieldKey]
  return formatDisplayValue(
    row.compareStatus === 'REMOVED' ? field?.baseValue : field?.targetValue
  )
}

export function isIdeonFieldModified(
  row: IdeonCompareRow,
  fieldKey: string
): boolean {
  return (
    row.compareStatus === 'MODIFIED' && !!row.fieldCompare[fieldKey]?.isModified
  )
}

export function IdeonDiffCellRenderer({
  row,
  fieldKey,
}: {
  row: IdeonCompareRow
  fieldKey: string
}) {
  const displayValue = getIdeonCellValue(row, fieldKey)

  if (row.compareStatus === 'REMOVED') {
    return (
      <span className={`${styles.diffCellText} ${styles.diffCellRemoved}`}>
        {displayValue}
      </span>
    )
  }

  if (!isIdeonFieldModified(row, fieldKey)) {
    return (
      <span className={`${styles.diffCellText} ${styles.diffCellDefault}`}>
        {displayValue}
      </span>
    )
  }

  const baseValue = formatDisplayValue(row.fieldCompare[fieldKey]?.baseValue)
  return (
    <Tooltip
      title={
        <span>
          Base: {baseValue || '(empty)'}
          <br />
          Compare to: {displayValue || '(empty)'}
        </span>
      }
      placement="topLeft"
    >
      <span
        className={`${styles.diffCellText} ${styles.diffCellChanged} ${styles.diffCellChangedValue}`}
      >
        {displayValue || ' '}
      </span>
    </Tooltip>
  )
}
